import React from "react";
import { Header, ActiveOrders } from "../components";
import { Box } from "@mui/material";

const Orders = () => {
  return (
    <Box>
      <Header />
      <ActiveOrders />
    </Box>
  );
};

export default Orders;
